import { render, staticRenderFns } from "./MotifyPassword.vue?vue&type=template&id=2113d332&"
import script from "./MotifyPassword.vue?vue&type=script&lang=ts&"
export * from "./MotifyPassword.vue?vue&type=script&lang=ts&"
import style0 from "./MotifyPassword.vue?vue&type=style&index=0&id=2113d332&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports